/** Growth Portal routes (canonical marketing / onboarding URLs). */
export const GROWTH_ROUTES = {
  /** 站点根路径 */
  ROOT: "/",
  /** 落地页 */
  LANDING_PAGE: "/landing-page",
  /** 落地页 - 联系销售 */
  LANDING_PAGE_CONTACT_SALES: "/landing-page/contact-sales",
  /** 广告主入驻 / 引导流程入口 */
  ON_BOARDING: "/onboarding",
  /** Onboarding 项目会话页（动态路由） */
  ON_BOARDING_PROJECT_HREF: (projectId: string) =>
    `/onboarding/${projectId}` as const,
} as const;

/** Dashboard (nested under `/dashboard`) route helpers. */
export const DASHBOARD_ROUTES = {
  DASHBOARD: "/dashboard",
  CAMPAIGNS: "/dashboard/campaigns",
  CAMPAIGN_DETAIL_HREF: (campaignId: string) =>
    `/dashboard/campaigns/${campaignId}` as const,
} as const;

/** Flat exports matching previous dashboard route names. */
export const CAMPAIGNS = DASHBOARD_ROUTES.CAMPAIGNS;
export const CAMPAIGN_DETAIL_HREF = DASHBOARD_ROUTES.CAMPAIGN_DETAIL_HREF;

/**
 * 需要登录才可访问的路由前缀列表（用于 middleware/proxy 等统一拦截）。
 *
 * - `"/onboarding"`：入口页
 * - `"/onboarding/"`：动态路由页（如 /onboarding/:projectId）
 */
export const AUTH_REQUIRED_ROUTE_PREFIXES = [
  GROWTH_ROUTES.ON_BOARDING,
  `${GROWTH_ROUTES.ON_BOARDING}/`,
  DASHBOARD_ROUTES.CAMPAIGNS,
  DASHBOARD_ROUTES.DASHBOARD,
  `${DASHBOARD_ROUTES.CAMPAIGNS}/`,
] as const;

/** Single object referencing both apps’ route maps (no key flattening / collisions). */
export const MERGED_ROUTES = {
  growth: GROWTH_ROUTES,
  dashboard: DASHBOARD_ROUTES,
} as const;
